import { ReactNode } from 'react';
import { ToastContainer } from 'react-toastify';

export const AppProviders = ({ children }: { children: ReactNode }) => {
  return (
    <>
      {children}
      <ToastContainer
        position="top-right"
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        // eslint-disable-next-line react/forbid-component-props
        style={{
          padding: '30px',
        }}
      />
    </>
  );
};
